module.exports = __webpack_public_path__ + "img/onboarding-checkout.dcd2a338.jpg";